import { atom } from "jotai"

export interface ReferralAtom {
  referralCode: string
  referrer: string
}

export const referralAtom = atom<ReferralAtom>({
  referralCode: "",
  referrer: "",
})

export const referralFirstLoadingAtom = atom<boolean>(false)
